import React, { useState } from 'react';
import './DedicatedTurkey.css';

const DedicatedTurkey = () => {
  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  const plans = [
    {
      tier: 'شروع',
      price: '۸۵۰',
      unit: 'هزار تومان / ماه',
      cpu: 'Intel Xeon E3',
      ram: '16 GB',
      storage: '2x240 GB SSD',
      features: ['لوکیشن ترکیه', 'پینگ عالی برای ایران', 'قیمت مناسب', 'پشتیبانی ۲۴/۷'],
      popular: false,
    },
    {
      tier: 'پیشرفته',
      price: '۱,۴۵۰',
      unit: 'هزار تومان / ماه',
      cpu: 'Intel Xeon E5',
      ram: '32 GB',
      storage: '2x480 GB SSD',
      features: ['لوکیشن ترکیه', 'پینگ عالی برای ایران', 'قیمت مناسب', 'پشتیبانی ۲۴/۷', 'IP اختصاصی'],
      popular: true,
    },
    {
      tier: 'حرفه‌ای',
      price: '۲,۴۰۰',
      unit: 'هزار تومان / ماه',
      cpu: 'Intel Xeon Gold',
      ram: '64 GB',
      storage: '2x960 GB NVMe',
      features: ['لوکیشن ترکیه', 'پینگ عالی برای ایران', 'قیمت مناسب', 'پشتیبانی ۲۴/۷', 'IP اختصاصی', 'اولویت پشتیبانی'],
      popular: false,
    },
  ];

  return (
    <>
      <div className="seo-header">
        <h1>سرور اختصاصی ترکیه | خرید سرور اختصاصی ترکیه با بهترین قیمت | افراسل</h1>
        <p>خرید سرور اختصاصی ترکیه با پینگ عالی برای ایران، قیمت مناسب و پشتیبانی ۲۴ ساعته.</p>
        <meta name="description" content="خرید سرور اختصاصی ترکیه با بهترین قیمت از افراسل. سرور اختصاصی ترکیه با پینگ عالی، قیمت مناسب و پشتیبانی ۲۴/۷." />
      </div>

      <section className="dedicatedturkey-hero">
        <div className="dedicatedturkey-hero-bg"></div>
        <div className="wrap">
          <div className="dedicatedturkey-hero-content">
            <div className="dedicatedturkey-badge">
              <span className="pulse-dot"></span>
              🇹🇷 سرور اختصاصی ترکیه
            </div>
            <h1 className="dedicatedturkey-hero-title">
              سرور اختصاصی <em>ترکیه</em>
            </h1>
            <p className="dedicatedturkey-hero-desc">
              سرور اختصاصی ترکیه با پینگ عالی برای ایران، قیمت مناسب و پشتیبانی ۲۴ ساعته.
              بهترین گزینه برای وب‌سایت‌های فارسی و کسب‌وکارهای منطقه‌ای.
            </p>
            <div className="dedicatedturkey-hero-stats">
              <div className="stat-item">
                <span className="stat-number">۳</span>
                <span className="stat-label">پلن مختلف</span>
              </div>
              <div className="stat-item">
                <span className="stat-number">ترکیه</span>
                <span className="stat-label">لوکیشن</span>
              </div>
              <div className="stat-item">
                <span className="stat-number">۲۴/۷</span>
                <span className="stat-label">پشتیبانی</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="dedicatedturkey-plans">
        <div className="wrap">
          <div className="sec-header">
            <span className="sec-tag">پلن‌های سرور اختصاصی ترکیه</span>
            <h2 className="sec-h">پلن <em>مناسب</em> کسب‌وکار خود را انتخاب کنید</h2>
            <p className="sec-p">پلن‌های متنوع سرور اختصاصی ترکیه با قیمت‌های رقابتی.</p>
          </div>
          <div className="dedicatedturkey-plans-grid">
            {plans.map((plan, i) => (
              <div key={i} className={`dedicatedturkey-plan ${plan.popular ? 'popular' : ''}`}>
                {plan.popular && <span className="dedicatedturkey-popular-badge">پرفروش‌ترین</span>}
                <div className="dedicatedturkey-plan-tier">{plan.tier}</div>
                <div className="dedicatedturkey-plan-price">
                  <span className="dedicatedturkey-plan-num">{plan.price}</span>
                  <span className="dedicatedturkey-plan-unit">{plan.unit}</span>
                </div>
                <div className="dedicatedturkey-plan-specs">
                  <div><span>🖥️</span> {plan.cpu}</div>
                  <div><span>💾</span> {plan.ram}</div>
                  <div><span>📀</span> {plan.storage}</div>
                </div>
                <ul className="dedicatedturkey-plan-features">
                  {plan.features.map((feat, j) => (
                    <li key={j}><span>✓</span> {feat}</li>
                  ))}
                </ul>
                <button className="dedicatedturkey-order-btn" onClick={() => scrollTo('contact')}>سفارش دهید</button>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="dedicatedturkey-cta">
        <div className="wrap">
          <div className="cta-box">
            <h2 className="cta-title">
              سرور اختصاصی <em>ترکیه</em> را همین حالا خریداری کنید
            </h2>
            <p className="cta-desc">
              با خرید سرور اختصاصی ترکیه، از پینگ عالی، قیمت مناسب و پشتیبانی ۲۴ ساعته بهره‌مند شوید.
            </p>
            <div className="cta-btns">
              <button className="btn-lg primary" onClick={() => scrollTo('contact')}>خرید سرور</button>
              <button className="btn-lg ghost" onClick={() => scrollTo('contact')}>مشاوره رایگان</button>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default DedicatedTurkey;
